<template>
    <b-container class="no-gutters p-0 pt-1 w-100 ">
        <b-row align-h="start" class="w-100">
            <b-input-group size="lg" class="w-100 pl-1">
                <b-col sm="auto" aligh-h="start" cols="2">
                    <b-input-group-prepend class="align-items-center">
                        <!-- Emission d'evenements selon l'êtat de la dropdown afin de transmettre un booleen soit à Analysis soit à WidgetConfig (show / hide)  -->
                        <b-dropdown @show="$emit('ChangeOverflowEvent', true)" @hide="$emit('ChangeOverflowEvent', false)" :variant="'outline-' + Variant" toggle-class="btn-circle border-0 " no-caret  menu-class="p-0 enlarge" v-b-tooltip.hover :title="$t('MaskManagement')" > <!-- "Gestion des masques" -->
                            <template #button-content >
                                <b-icon v-if="Object.keys(selectedMask).length == 0" icon="bookmarks" />
                                <b-icon v-else icon="bookmarks-fill" />
                            </template>

                            <b-dropdown-group :header="$t('RecentMasks')" > <!-- "Masques récents" -->
                                <b-dropdown-item @click="load(m.Id)" v-for="m in lastMasks" :key="m.Id">
                                    <b-row>
                                        <b-col class="text-truncate" v-b-tooltip.hover :title="m.Label" >
                                            {{m.Label}}
                                        </b-col>
                                        <!-- <b-col cols="auto" >
                                            <b-icon @click.stop="deleteMask(m.Id)" role="button" icon="x-lg" class="text-danger" />
                                        </b-col> -->
                                    </b-row>
                                </b-dropdown-item>
                            </b-dropdown-group>

                            <b-dropdown-form class="text-center">
                                <b-button @click="masksVisible = !masksVisible" :variant="'outline-' + Variant" pill >{{$t('ShowAllMasks')}}</b-button> <!-- "Voir tous les masques enregistrés" -->
                            </b-dropdown-form>
                        </b-dropdown>

                        <template v-if="Object.keys(selectedMask).length == 0">
                            <b-col class="text-gray-dark p-0 px-1" >
                                <small>{{$t('NoMaskApplied')}}</small> <!-- "Aucun masque enregistré appliqué" -->
                            </b-col>
                        </template>
                        <template v-else >
                            <b-col class="text-black text-truncate p-0 px-1" v-b-tooltip.hover :title="selectedMask.Name">
                                <small>{{selectedMask.Name}}</small>
                            </b-col>
                            <b-col cols="auto" class="px-0">
                                <!-- Réinitialise le masque appliqué -->
                                <small>
                                    <b-link v-if="selectedMask.Id > 0" @click="load(selectedMask.Id)" class="p-2">{{$t('Reset')}}</b-link> <!-- "Réinitialiser" -->
                                </small>

                                <!-- Déselectionne le masque appliqué -->
                                <small>
                                    <b-link v-if="selectedMask.Id > 0" @click="removeMask()" class="p-2 text-danger">{{$t('Remove')}}</b-link> <!-- "Enlever" -->
                                </small>
                            </b-col>
                        </template>
                    </b-input-group-prepend>
                </b-col>
            </b-input-group>
        </b-row>
        <b-row class="w-100 pl-2">
            <b-col class="text-gray-dark text-left" align-self="center">
                <small v-if="updateDate" >{{$t('LastUpdate', { time: updateDate })}}</small> <!-- "Dernière actualisation à {updateDate}" -->
            </b-col>
            <b-col cols="auto" class="pr-0">
                <b-button @click="addMaskVisible = !addMaskVisible;" v-b-tooltip.hover :title="$t('SaveMask')" variant="outline-black" class="border-0 btn-circle m-1"> <!-- "Enregistrer le masque" -->
                    <i class="bi bi-floppy" />
                </b-button>
                <!-- TODO : Ce bouton doit désélectionner le masque actif et charger le masque par défaut -->
                <!-- Annuler => Masque par défaut ?   -->
                <b-button @click="load(selectedMask.Id)" v-b-tooltip.hover :title="$t('Cancel')" variant="outline-black" class="border-0 btn-circle ml-0 mr-1 my-1"> <!-- "Annuler" -->
                    <b-iconstack scale="1.1">
                        <b-icon icon="arrow-counterclockwise" rotate="45" shift-h="-0.7" shift-v="0.9"  />
                        <b-icon icon="x" font-scale="0.94" shift-h="1.5" shift-v="-1.8" />
                    </b-iconstack>
                </b-button>
            </b-col>
        </b-row>

        <!-- Modale pour afficher tous les masques -->
        <b-modal v-model="masksVisible" centered no-close-on-backdrop>
            <template #modal-header="{ close }">
                <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                    <b-col class="text-left">
                        <h6>{{$t('SavedMasks')}}</h6> <!-- "Masques enregistrés" -->
                    </b-col>
                    <b-col class=" pr-0 p-1 pl-4 text-right">
                        <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close();" v-b-tooltip.hover :title="$t('Close')" /> <!-- "Fermer" -->
                    </b-col>
                </b-row>
            </template>

            <template #default="{ close }">
                <!-- Barre de recherche -->
                <b-input-group>
                    <template #prepend>
                        <b-input-group-text><b-icon icon="search"/></b-input-group-text>
                    </template>

                    <b-form-input v-model="searchValue" :placeholder="$t('SearchMaskPlaceholder')"/> <!-- "Rechercher un masque enregistré" -->
                </b-input-group>

                <!-- Tableau d'affichage avec pagination des masques de configuration -->   
                <b-table fixed :id="$id('masksList')" responsive selectable select-mode="single" :items="allMasks" :fields="fieldMasks" :per-page="itemPerPage" :current-page="currentPage" 
                    :filter="searchValue" thead-class="d-none" tbody-tr-class="d-flex" @row-selected="maskRowSelected" @filtered="onFiltered" >
                    <template #cell(Label)="data">
                            {{data.value}}
                    </template>
                    
                    <template #cell(Id)="data" >
                        <b-icon @click.stop="deleteMask(data.value)" role="button" icon="x" scale="2" />
                    </template>
                </b-table>

            </template>

            <template #modal-footer="{ close }">
                <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="itemPerPage" class="mr-auto" />
                <b-button @click="close();searchValue = ''" :variant="'outline-' + Variant" pill class="mr-1">{{$t('Cancel')}}</b-button> <!-- "Annuler" -->
                <b-button @click="load(selectedMaskId);close()" :disabled="selectedMaskId == 0" pill :variant="Variant">{{$t('Apply')}}</b-button> <!-- "Appliquer" -->
            </template>


        </b-modal>

        <!-- Modale pour ajouter un masque -->
        <b-modal v-model="addMaskVisible" centered no-close-on-backdrop>
            <template #modal-header="{ close }">
                <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                    <b-col v-if="Object.keys(selectedMask).length == 0" >
                        {{$t('NewMask')}} <!-- "Nouveau masque" -->
                    </b-col>
                    <b-col v-else >
                        {{$t('UpdateMask')}} <!-- "Mise à jour masque" -->
                    </b-col>
                    <b-col class=" pr-0 p-1 pl-4 text-right">
                        <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close();" v-b-tooltip.hover :title="$t('Close')" /> <!-- "Fermer" -->
                    </b-col>
                </b-row>
            </template>

            <template #modal-footer="{close}">
                <b-row>
                    <b-button @click="close(); isMaskValid= null" :variant="'outline-' + Variant" pill class="mx-1">{{$t('Cancel')}}</b-button> <!-- "Annuler" -->
                    <b-button @click="save()" :variant="Variant" pill >{{$t('Add')}}</b-button> <!-- "Ajouter" -->
                </b-row>
            </template>

            <b-form-group :label="$t('MaskName')" label-cols="3" > <!-- "Nom du masque" -->
                <b-form-input v-model="maskName" :placeholder="$t('EnterMaskName')" :state="isMaskValid" ></b-form-input> <!-- "Entrez le nom du masque" -->

                <b-form-invalid-feedback  :state="isMaskValid">
                    {{$t('MaskNameEmpty')}} <!-- "Le nom du masque ne peut pas être vide." -->
                </b-form-invalid-feedback>
            </b-form-group>
        </b-modal>
    </b-container>
</template>

<script lang="ts">
    import { Vue, PropSync, Watch, Prop } from 'vue-property-decorator';
    import { API_URL } from '@/App.settings';
    import Component from 'vue-class-component';
    import Dictionary from '@/types/Dictionary';
    import axios from 'axios';
    import ListItem from '@/types/fields/ListItem';
    import Mask from '@/types/Config/Mask';
    /** Traductions */
    import locales from "./locales/Masks.json";

    /** Template pour la gestion des masques de configuration */
    @Component({
        components: {

        },
        i18n: { messages: locales }
    })
    export default class Masks extends Vue {
		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "Primary" })
		public Variant!: string;

        /** Nom de la fonction actuelle*/
        @Prop()
        public FeatureName!: string;

        /** Nom du masque à enregistrer*/
        private maskName: string = "";

        /** Permet de changer entre l'affichage des derniers masques et l'ajout d'un masque*/
        private addMaskVisible: boolean = false;

        /** Permet d'afficher ou non la modale des masques enregistrés*/
        private masksVisible: boolean = false;

        /** état pour validation nom du masque */
        private isMaskValid: boolean = null;

        /** Liste des tous les masques*/
        private allMasks: ListItem[] = [];

        /** Liste des X derniers masques*/
        private lastMasks: ListItem[] = [];

        /** Valeur pour rechercher un masque */
        private searchValue: string = "";

        /** Numero de l'identifiant du masque à charger */
        private selectedMaskId: number = 0;

        /** Nombre d'éléments à afficher pour lastMasks*/
        private lastNumber: number = 5;
        
        /** Correspond à l'heure de la dernière actualisation */
        private updateDate: string = "";  

        /** Tableau des colonnes des masques à afficher */
        private fieldMasks = [
            {
                key:"Label",
                label:"",
                tdClass:"text-truncate w-100"
            },
            {
                key:"Id",
                label:"",
                tdClass:"text-danger"
            }
        ];

        /** Numero de la page courante de la pagination des masques */
        private currentPage: number = 1;

        /** Nombre d'éléments à afficher par page */
        private itemPerPage: number = 5;

        /** Nombre de ligne de données pour la pagination  */
        private totalRows: number = 1;

        /** Rechargement de la liste de masques */
        @PropSync('Reload', { default: () => false })
        public reload!: boolean;

        @Watch('reload')
        private reloadMasks() {

            console.debug("Masks - reloadMasks");

            if (this.reload)
                this.getMasks().then(() => {
                    this.reload = false;
                })
        }

        /**
         * Sélectionne l'identifiant du masque afin de l'appliquer
         * @param row Ligne dans le tableau des masques
         */
        private maskRowSelected(row){

            console.debug("Masks - maskRowSelected - row :", row);;
            if(row.length == 1)
                this.selectedMaskId = row[0].Id;
            else
                this.selectedMaskId = 0;
        }

        /**
         * Fonction pour filtrer les masques dans le b-table
         * @param filteredItems liste des masques filtrés selon la valeur recherchée 
         */
        private onFiltered(filteredItems){
            this.totalRows = filteredItems.length
            this.currentPage = 1;
        }

        /** Masque sélectionné */
        @PropSync('SelectedMask', { default: () => {} })
        public selectedMask!: Mask;

        /** Chargement de tous les masques */
        @Watch("FeatureName", { immediate: true})
        private async getMasks() {
            if (this.FeatureName) {
                const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

                this.updateDate = "";

                await axios.post<ListItem[]>(API_URL + "Feature/" + this.FeatureName + "/LoadMasks", args).then((response) => {
                    if (response && response.data) {                    
                        this.allMasks = response.data;
                        this.totalRows = this.allMasks.length;

                        this.lastMasks = [...this.allMasks];
                        this.lastMasks = this.lastMasks.slice(0, this.lastNumber);

                        console.debug("Masks - getMasks() - this.allMasks :", this.allMasks);
                        console.debug("Masks - getMasks() - this.lastMasks :", this.lastMasks);
                    }
                });
            }
        }

        /**
         * Déselectionne le masque en cours
         */
        private removeMask(){
            this.selectedMask = {} as Mask;
            this.maskName = "";
            this.updateDate = "";
        }


        /** Enregistrement du masque */
        private async save() {

            console.debug("Masks - save - this.maskName", this.maskName);
            console.debug("Masks - save - this.maskName.length === 0", this.maskName.trim().length === 0);

            if( this.maskName.trim().length === 0 ){
                this.isMaskValid = false;
                
            }
            else{
                this.$emit("SaveMasksEvent", this.maskName);
                this.load(this.selectedMask.Id);
                this.addMaskVisible = false;
                this.isMaskValid = null;
            }    
        }

        /**
         * Chargement d'un masque
         * @param id identifiant du masque à charger
         */
        private async load(id: number) {
            const args: Dictionary<any> = {};

            //Arguments
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["Id"] = id;

            await axios.post(API_URL + "Feature/" + this.FeatureName + "/LoadMask", args).then((response) => {
                if(response && response.data){
                    this.selectedMask = response.data;
                    this.maskName = response.data.Name;

                    // met la date au format HH:mm en prenant en compte les valeurs inf. à 10.
                    this.updateDate = String(new Date().getHours()).padStart(2, '0') + ":" + String(new Date().getMinutes()).padStart(2, '0');
                }

            });
        }

        /**
         * Suppression d'un masque
         * @param id idenytifiant du masque à supprimer
         */
        private async deleteMask(id: number) {
            const args: Dictionary<any> = {};

            //Arguments
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["Id"] = id;

            await axios.post(API_URL + "Feature/" + this.FeatureName + "/DeleteMask", args).then(async () => {
                await this.getMasks();

                if (this.selectedMask.Id == id) {
                    this.removeMask();
                }
            });
        }
    }
</script>

<style scoped>

/* Style pour fixer la taille de la dropdown des masques récents  */
:deep(.dropdown-menu.show.enlarge) {
        min-width: 20rem !important;
        max-width: 20rem !important;
}
</style>